import * as _mq from './mq.module.scss';

export type mqTypes = Partial<_mq.Styles>;
export default _mq as unknown as _mq.Styles;
